import { useEffect, useState } from "react";
import { useAuth } from "../../../../../modules/auth";
import { useLazyReadMultipleQuery } from "../../../../services/data/tableDataApi";
import { ICourse } from "./assessment";

export const useGetCoursesName = () => {
    const { user, siteId } = useAuth();
    const [getCourses] = useLazyReadMultipleQuery();
    const [courses, setCourses] = useState<Map<string, string>>(new Map());
  
    useEffect(() => {
      const fetchCourses = async () => {
        if (!user?.contactId) {
          return;
        }
  
        try {
          const data = await getCourses({
            userId: user?.userId || '',
            portalId: siteId || '',
            tableId: "mshied_course", 
            fieldList: ["mshied_courseid", "mshied_name"], 
            filters: []
          }).unwrap(); 
  
          // Type assertion to ensure correct type for data.records
          const courseMap = new Map<string, string>(
            (data.records as ICourse[]).map((p) => [p.mshied_courseid, p.mshied_name])
          );
  
          setCourses(courseMap);
        } catch (error) {
          console.error("Error fetching courses:", error);
        }
      };
  
      fetchCourses();
    }, [user, siteId, getCourses]);
  
    // Function to get course name by ID
    const getCourseName = (key: string) => {
      return courses.get(key) || "";
    };
  
    return { getCourseName };
  };
  